// extracted by mini-css-extract-plugin
export default {"container":"ModalSide_container__crK9B","top":"ModalSide_top__IhqdH","button":"ModalSide_button__5m9E2","close":"ModalSide_close__PRzwF","content":"ModalSide_content__aMKgQ"};